
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dhbEh", function(module, exports) {
/* ForgeContentTools.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $inPa6 = parcelRequire("inPa6");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $7Ndnw = parcelRequire("7Ndnw");


var $7QUD1 = parcelRequire("7QUD1");


var $hIaUw = parcelRequire("hIaUw");


var $8a9Dm = parcelRequire("8a9Dm");


var $dizL5 = parcelRequire("dizL5");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");


var $6UqI3 = parcelRequire("6UqI3");


var $6uUjl = parcelRequire("6uUjl");


var $3IBnw = parcelRequire("3IBnw");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3jwuS = parcelRequire("3jwuS");


var $c54hr = parcelRequire("c54hr");


var $9wGTI = parcelRequire("9wGTI");

/* ForgeContentToolsItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $9hlns = parcelRequire("9hlns");


var $9fBoq = parcelRequire("9fBoq");


var $al4VD = parcelRequire("al4VD");

const $ced39bfea5ef5993$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLoading: isLoading, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_kqswh2mm",
            __cmplp.isLoading ? "_syaz1rpy" : "_syazn7od",
            __cmplp.className
        ])
    });
});
const $ced39bfea5ef5993$var$CenterSpinner = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18u0x0bf _19pkx0bf _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
function $ced39bfea5ef5993$export$9f275aff884e1431({ extension: extension, onClick: onClick, isLoading: isLoading }) {
    const onClickCB = (0, $42omo.useCallback)((e)=>{
        e.stopPropagation();
        onClick(extension);
    }, [
        extension,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $al4VD.ContentToolsItem), {
        id: extension.id,
        isDisabled: isLoading,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$Container, {
            isLoading: isLoading
        }, (0, $9fBoq.extensionTitle)(extension), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$CenterSpinner, {
            "data-test-id": "forge-ui-extension-loading-spinner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "small"
        }))),
        onClick: onClickCB
    });
}
$ced39bfea5ef5993$export$9f275aff884e1431.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool.isRequired
};



var $9MrOn = parcelRequire("9MrOn");

const $0c33e41081c1500e$var$EXPERIENCE_NAME = (0, $irVI7.VIEW_PAGE_CONTENT_TOOLS_FORGE_EXPERIENCE);
function $0c33e41081c1500e$export$7cf22b806dbb23cb({ contentId: contentId, spaceKey: spaceKey, children: children, onLoadComplete: onLoadComplete, isDropdownMenuOpen: isDropdownMenuOpen, dialogs: dialogs, lazyLoaderPlaceholderComponent: lazyLoaderPlaceholderComponent = null }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext)); // Forge menu items are behaving a little different than other menu items. They show a loading spinner if one of them
    // is clicked. There are a few different cases that needs to be handled while a forge extension is being loaded:
    // 1. Show a loading spinner while an extension id being loaded.
    //    - Stop showing the loading spinner once the extension is loaded.
    //    - Close the dropdown menu once the extension is loaded.
    // 2. If dropdown menu is closed while an extension is being loaded then stop loading the extension.
    // If there's a selected extension then `loadExtension` state changes like this:
    // +----------+----------------------+------------------+
    // |isLoading |   isDropdownMenuOpen |    loadExtension |
    // +----------------------------------------------------+
    // |          |                      |                  |
    // | false    |   false              |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | false    |   true               |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | true     |   false              |    false         |  --> stop loading the extension
    // |          |                      |                  |
    // | true     |   true               |    true          |  --> keep loading the extension
    // +----------+----------------------+------------------+
    const [extension, showExtension] = (0, $42omo.useState)(null);
    const [isLoading, setLoading] = (0, $42omo.useState)(false);
    const loadExtension = extension && !(isLoading && !isDropdownMenuOpen); // Dialogs may not be needed anymore for live pages - this is a fix for a Forge issue where this is causing re-renders and app is losing context
    // See: https://atlassian.slack.com/archives/CFHD7ERB4/p1755775542436799?thread_ts=1754500884.539789&cid=CFHD7ERB4
    const dialogsProp = (0, $9wGTI.fg)('confluence_skip_dialogs_prop') ? undefined : dialogs;
    (0, $42omo.useEffect)(()=>{
        if (!loadExtension) {
            experienceTracker.abort({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
                reason: 'Canceled by user'
            });
            setLoading(false);
            showExtension(null);
        }
    }, [
        loadExtension,
        experienceTracker
    ]);
    const onLoadCompleteCB = (0, $42omo.useCallback)(()=>{
        onLoadComplete();
        setLoading(false);
    }, [
        onLoadComplete,
        setLoading
    ]);
    const onCloseCB = (0, $42omo.useCallback)(()=>{
        showExtension(null);
    }, [
        showExtension
    ]);
    const onForgeExtensionClick = (0, $42omo.useCallback)((ext)=>{
        experienceTracker.start({
            name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
            id: ext.id,
            timeout: 10000
        });
        showExtension(ext);
        setLoading(true);
    }, [
        showExtension,
        setLoading,
        experienceTracker
    ]);
    // shows up when preloaded in SSR. Shows up again when SPA takes over bf all queries are loaded.
    const LazyLoader = (0, $42omo.useMemo)(()=>(0, $dizL5.lazyForgeUIExtensionsWithLoader)(()=>lazyLoaderPlaceholderComponent ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9MrOn.ContentToolsButton // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            ), {
                isDisabled: !(window.__SSR_RENDERED__ || undefined)
            })), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, loadExtension && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$ForgeUIExtensionLoader, {
        extension: extension,
        contentId: contentId,
        spaceKey: spaceKey,
        onLoadComplete: onLoadCompleteCB,
        onClose: onCloseCB,
        dialogs: dialogsProp
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(LazyLoader, {
        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
        render: (extensions, loading, error)=>{
            if (loading) return children([]);
            if (error) {
                if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                    attribution: (0, $3IBnw.Attribution).ECOSYSTEM
                });
                return children([]);
            }
            const result = extensions.map((ext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ced39bfea5ef5993$export$9f275aff884e1431), {
                    key: ext.id,
                    extension: ext,
                    onClick: onForgeExtensionClick,
                    isLoading: extension === ext
                }));
            return children(result);
        }
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0c33e41081c1500e$var$InvisibleDiv = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0cglyw",
            __cmplp.className
        ])
    });
}); /**
     * LazyForgeUIExtension has its own loading spinner, however, we don't want to show it anywhere. We want to show a
     * loading spinner inside the menu item while loading the extension, and then close the menu once the loading is complete.
     * To accomplish that, we're rendering LazyForgeUIExtension inside an invisible div.
     * @param forgeExtension To be loaded.
     * @param contentId Passed down to ForgeUIExtension both contentId and spaceKey becomes available in the forge app with
     * `useProductContext` hook. For reference https://developer.atlassian.com/platform/forge/ui-hooks-reference/.
     * @param spaceKey Passed down to ForgeUIExtension.
     * @param onLoadComplete Triggered when the forge extension is loaded.
     * @param onClose Triggered when the rendered ModalDialog is closed. (Currently ContentAction forge component can only contain a ModalDialog)
     * @returns LazyForgeUIExtension inside an InvisibleDiv.
     * @constructor
     */ 
function $0c33e41081c1500e$var$ForgeUIExtensionLoader({ extension: extension, contentId: contentId, spaceKey: spaceAlias, onLoadComplete: onLoadComplete, onClose: onClose, dialogs: dialogs }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [{ routeName: routeName }] = (0, $ep3mz.usePageState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { setIsCloseMenuDisabled: setIsCloseMenuDisabled } = (0, $c54hr.useMoreActionsMenuActions)();
    (0, $42omo.useEffect)(()=>{
        if ((0, $9wGTI.fg)('forge-ui-content-action-modal-closing-fix')) // Ensures the MoreActions dialog remains opened while the Forge app is running
        // Without this, interactions with any portals from UI Kit components will close the menu which closes the Forge app
        setIsCloseMenuDisabled(true);
        return ()=>{
            if ((0, $9wGTI.fg)('forge-ui-content-action-modal-closing-fix')) setIsCloseMenuDisabled(false);
        };
    }, [
        setIsCloseMenuDisabled
    ]);
    const onInitialRender = (0, $42omo.useCallback)(()=>{
        experienceTracker.succeed({
            name: $0c33e41081c1500e$var$EXPERIENCE_NAME
        });
        onLoadComplete();
        const appId = (0, $8a9Dm.getAppId)(extension);
        const analyticEvent = createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'invoked',
                actionSubject: 'forgeExtension',
                actionSubjectId: appId,
                containerType: 'space',
                containerId: spaceId,
                objectType: (0, $hIaUw.getContentType)(routeName),
                objectId: contentId,
                source: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                attributes: {
                    activationId: activationId,
                    appId: appId,
                    moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                    moduleKey: (0, $8a9Dm.getModuleKey)(extension),
                    spaceType: (0, $6UqI3.getSpaceType)(spaceAlias),
                    spaceId: spaceId
                }
            }
        });
        analyticEvent.fire();
    }, [
        onLoadComplete,
        experienceTracker,
        activationId,
        createAnalyticsEvent,
        contentId,
        spaceAlias,
        spaceId,
        extension,
        routeName
    ]);
    if (!spaceKey) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$InvisibleDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7QUD1.ContentActionForgeApp // this key is required to enable user switch in between different forge apps during loading of an extension
    ), {
        key: extension.id,
        app: extension,
        extensionData: {
            type: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
            // This ts ignore can be removed once the ff is cleaned up.
            // @ts-ignore FIXME `type` is declared by `extensionData` to be required for `content`
            content: {
                id: contentId,
                subtype: isLivePage ? 'live' : null,
                ...(0, $9wGTI.fg)('confluence_forge_content_type_in_content_actions') ? {
                    type: (0, $hIaUw.getContentType)(routeName)
                } : {}
            },
            space: {
                key: spaceKey || spaceAlias,
                id: spaceId
            }
        },
        onInitialRender: onInitialRender,
        onTearDown: ()=>{
            if ((0, $9wGTI.fg)('forge-ui-content-action-modal-closing-fix')) setIsCloseMenuDisabled(false);
            onClose();
        },
        dialogs: dialogs
    }));
}
$0c33e41081c1500e$var$ForgeUIExtensionLoader.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    onLoadComplete: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
};
module.exports["ForgeContentTools"] = $0c33e41081c1500e$export$7cf22b806dbb23cb;

});

parcelRegister("7Ndnw", function(module, exports) {
const $af2b0e533822f413$export$77aa6bcc53373193 = 'confluence:contentBylineItem';
const $af2b0e533822f413$export$dfd79dc5aae7414d = 'confluence:contextMenu';
const $af2b0e533822f413$export$93827e7f1bb6974c = 'confluence:contentAction';
const $af2b0e533822f413$export$6a8e7521883fbbdb = 'confluence:fullPage';
const $af2b0e533822f413$export$931827627b89a6ba = 'confluence:globalPage';
const $af2b0e533822f413$export$109ae14a8174901f = 'confluence:globalSettings';
const $af2b0e533822f413$export$e31530da5c277984 = 'confluence:homepageFeed';
const $af2b0e533822f413$export$54edc26d40e1a8eb = 'confluence:pageBanner';
const $af2b0e533822f413$export$75695e15f2aab495 = 'confluence:spacePage';
const $af2b0e533822f413$export$f17386882264cfae = 'confluence:spaceSettings';
const $af2b0e533822f413$export$3e9f3e416c5066aa = 'confluence:customContent';
const $af2b0e533822f413$export$b9c5c98eb97dff92 = 'confluence:backgroundScript';
const $af2b0e533822f413$export$c0df8ab57c5edc2a = 'test:module';
const $af2b0e533822f413$export$769f3a278705a683 = 'xen:macro';
const $af2b0e533822f413$export$492ceb220fc48ad2 = [
    $af2b0e533822f413$export$6a8e7521883fbbdb,
    $af2b0e533822f413$export$931827627b89a6ba,
    $af2b0e533822f413$export$109ae14a8174901f,
    $af2b0e533822f413$export$e31530da5c277984,
    $af2b0e533822f413$export$b9c5c98eb97dff92
];
const $af2b0e533822f413$export$ec6cdf0e930aca0a = [
    $af2b0e533822f413$export$75695e15f2aab495,
    $af2b0e533822f413$export$f17386882264cfae,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
const $af2b0e533822f413$export$344b997b63ff6612 = [
    $af2b0e533822f413$export$77aa6bcc53373193,
    $af2b0e533822f413$export$dfd79dc5aae7414d,
    $af2b0e533822f413$export$93827e7f1bb6974c,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
module.exports["FORGE_MODULE_BYLINE"] = $af2b0e533822f413$export$77aa6bcc53373193;
module.exports["FORGE_MODULE_CONTEXT_MENU"] = $af2b0e533822f413$export$dfd79dc5aae7414d;
module.exports["FORGE_MODULE_CONTENT_ACTION"] = $af2b0e533822f413$export$93827e7f1bb6974c;
module.exports["FORGE_MODULE_GLOBAL_PAGE"] = $af2b0e533822f413$export$931827627b89a6ba;
module.exports["FORGE_MODULE_GLOBAL_SETTINGS"] = $af2b0e533822f413$export$109ae14a8174901f;
module.exports["FORGE_MODULE_HOMEPAGE_FEED"] = $af2b0e533822f413$export$e31530da5c277984;
module.exports["FORGE_MODULE_PAGE_BANNER"] = $af2b0e533822f413$export$54edc26d40e1a8eb;
module.exports["FORGE_MODULE_SPACE_PAGE"] = $af2b0e533822f413$export$75695e15f2aab495;
module.exports["FORGE_MODULE_SPACE_SETTINGS"] = $af2b0e533822f413$export$f17386882264cfae;
module.exports["FORGE_MODULE_CUSTOM_CONTENT"] = $af2b0e533822f413$export$3e9f3e416c5066aa;
module.exports["FORGE_MODULE_BACKGROUND_SCRIPT"] = $af2b0e533822f413$export$b9c5c98eb97dff92;
module.exports["FORGE_MODULE_XEN_MACRO"] = $af2b0e533822f413$export$769f3a278705a683;
module.exports["forgeGlobalExtensions"] = $af2b0e533822f413$export$492ceb220fc48ad2;

});

parcelRegister("7QUD1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("lcfYp"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("2T9Dw"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("t4Jef"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$b8ad4f58faf0ae = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AI3JE",
    name: "FullPageForgeApp",
    loader: async ()=>(await (parcelRequire("5tnh5"))).FullPageForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("7359q"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("eDY8d"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("jKQL4"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("89h6z"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("aVgUi"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("jLqFe"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("gdpl8"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("4bplr"))).PageBannerForgeApp
});
module.exports["ByLineForgeApp"] = $02976f123c8f8e25$export$d2159b9f3f077903;
module.exports["ContentActionForgeApp"] = $02976f123c8f8e25$export$f900958ce7c4410f;
module.exports["ContextMenuForgeApp"] = $02976f123c8f8e25$export$79ed117743c6c2cf;
module.exports["GlobalPageForgeApp"] = $02976f123c8f8e25$export$83db8797814193a8;
module.exports["GlobalSettingsForgeApp"] = $02976f123c8f8e25$export$74528162c4c3828b;
module.exports["HomepageFeedForgeApp"] = $02976f123c8f8e25$export$c8291e2d6d6adbf2;
module.exports["SpaceSettingsForgeApp"] = $02976f123c8f8e25$export$e8858129e933f7e8;
module.exports["SpacePageForgeApp"] = $02976f123c8f8e25$export$60a905140138a1c8;
module.exports["CustomContentForgeApp"] = $02976f123c8f8e25$export$578d0cbdb0ffa72e;
module.exports["BackgroundScriptForgeApp"] = $02976f123c8f8e25$export$40d4b5cfa6c18ea7;
module.exports["PageBannerForgeApp"] = $02976f123c8f8e25$export$c76787f94e0b1609;

});

parcelRegister("lcfYp", function(module, exports) {

let $f6e71bef8b1d3053$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f6e71bef8b1d3053$var$load("2YffH"),
    $f6e71bef8b1d3053$var$load("8Kivm"),
    $f6e71bef8b1d3053$var$load("cf5vC"),
    $f6e71bef8b1d3053$var$load("A1eSR"),
    $f6e71bef8b1d3053$var$load("2rCak"),
    $f6e71bef8b1d3053$var$load("iQ0Jm"),
    $f6e71bef8b1d3053$var$load("coJiW"),
    $f6e71bef8b1d3053$var$load("eYere"),
    $f6e71bef8b1d3053$var$load("at1W4"),
    $f6e71bef8b1d3053$var$load("h4Nf7"),
    $f6e71bef8b1d3053$var$load("7f9Fz"),
    $f6e71bef8b1d3053$var$load("8YSo7"),
    $f6e71bef8b1d3053$var$load("fqGSw"),
    $f6e71bef8b1d3053$var$load("2Cftu"),
    $f6e71bef8b1d3053$var$load("4i0CB"),
    $f6e71bef8b1d3053$var$load("g9CVe"),
    $f6e71bef8b1d3053$var$load("49GA1"),
    $f6e71bef8b1d3053$var$load("32K9i"),
    $f6e71bef8b1d3053$var$load("aeEUI"),
    $f6e71bef8b1d3053$var$load("iXzmH"),
    $f6e71bef8b1d3053$var$load("65c4i"),
    $f6e71bef8b1d3053$var$load("6wr18"),
    $f6e71bef8b1d3053$var$load("kjZZD"),
    $f6e71bef8b1d3053$var$load("3TTZL"),
    $f6e71bef8b1d3053$var$load("37ldp"),
    $f6e71bef8b1d3053$var$load("jkPqm"),
    $f6e71bef8b1d3053$var$load("awqCy"),
    $f6e71bef8b1d3053$var$load("kHOMt"),
    $f6e71bef8b1d3053$var$load("hhss7"),
    $f6e71bef8b1d3053$var$load("ePdWC"),
    $f6e71bef8b1d3053$var$load("lBzRN"),
    $f6e71bef8b1d3053$var$load("9wxKg"),
    $f6e71bef8b1d3053$var$load("Wowvf"),
    $f6e71bef8b1d3053$var$load("6O8m6"),
    $f6e71bef8b1d3053$var$load("5GxU8"),
    $f6e71bef8b1d3053$var$load("7whwt"),
    $f6e71bef8b1d3053$var$load("699ae"),
    $f6e71bef8b1d3053$var$load("i7QCq"),
    $f6e71bef8b1d3053$var$load("let0D"),
    $f6e71bef8b1d3053$var$load("87NBA"),
    $f6e71bef8b1d3053$var$load("6M36W"),
    $f6e71bef8b1d3053$var$load("ffEVr"),
    $f6e71bef8b1d3053$var$load("kUbUu"),
    $f6e71bef8b1d3053$var$load("9ftJe"),
    $f6e71bef8b1d3053$var$load("hUIij"),
    $f6e71bef8b1d3053$var$load("6Up0b"),
    $f6e71bef8b1d3053$var$load("lnKog"),
    $f6e71bef8b1d3053$var$load("7Omhy"),
    $f6e71bef8b1d3053$var$load("kC80R"),
    $f6e71bef8b1d3053$var$load("7EorR"),
    $f6e71bef8b1d3053$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("2T9Dw", function(module, exports) {

let $21a8316b85a75cac$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $21a8316b85a75cac$var$load("2YffH"),
    $21a8316b85a75cac$var$load("8Kivm"),
    $21a8316b85a75cac$var$load("cf5vC"),
    $21a8316b85a75cac$var$load("A1eSR"),
    $21a8316b85a75cac$var$load("2rCak"),
    $21a8316b85a75cac$var$load("iQ0Jm"),
    $21a8316b85a75cac$var$load("coJiW"),
    $21a8316b85a75cac$var$load("eYere"),
    $21a8316b85a75cac$var$load("at1W4"),
    $21a8316b85a75cac$var$load("h4Nf7"),
    $21a8316b85a75cac$var$load("7f9Fz"),
    $21a8316b85a75cac$var$load("8YSo7"),
    $21a8316b85a75cac$var$load("fqGSw"),
    $21a8316b85a75cac$var$load("2Cftu"),
    $21a8316b85a75cac$var$load("4i0CB"),
    $21a8316b85a75cac$var$load("g9CVe"),
    $21a8316b85a75cac$var$load("49GA1"),
    $21a8316b85a75cac$var$load("32K9i"),
    $21a8316b85a75cac$var$load("aeEUI"),
    $21a8316b85a75cac$var$load("iXzmH"),
    $21a8316b85a75cac$var$load("65c4i"),
    $21a8316b85a75cac$var$load("6wr18"),
    $21a8316b85a75cac$var$load("kjZZD"),
    $21a8316b85a75cac$var$load("3TTZL"),
    $21a8316b85a75cac$var$load("37ldp"),
    $21a8316b85a75cac$var$load("jkPqm"),
    $21a8316b85a75cac$var$load("awqCy"),
    $21a8316b85a75cac$var$load("kHOMt"),
    $21a8316b85a75cac$var$load("hhss7"),
    $21a8316b85a75cac$var$load("ePdWC"),
    $21a8316b85a75cac$var$load("lBzRN"),
    $21a8316b85a75cac$var$load("9wxKg"),
    $21a8316b85a75cac$var$load("Wowvf"),
    $21a8316b85a75cac$var$load("6O8m6"),
    $21a8316b85a75cac$var$load("5GxU8"),
    $21a8316b85a75cac$var$load("7whwt"),
    $21a8316b85a75cac$var$load("699ae"),
    $21a8316b85a75cac$var$load("i7QCq"),
    $21a8316b85a75cac$var$load("let0D"),
    $21a8316b85a75cac$var$load("87NBA"),
    $21a8316b85a75cac$var$load("6M36W"),
    $21a8316b85a75cac$var$load("ffEVr"),
    $21a8316b85a75cac$var$load("kUbUu"),
    $21a8316b85a75cac$var$load("9ftJe"),
    $21a8316b85a75cac$var$load("hUIij"),
    $21a8316b85a75cac$var$load("6Up0b"),
    $21a8316b85a75cac$var$load("lnKog"),
    $21a8316b85a75cac$var$load("7Omhy"),
    $21a8316b85a75cac$var$load("kC80R"),
    $21a8316b85a75cac$var$load("7EorR"),
    $21a8316b85a75cac$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("t4Jef", function(module, exports) {

let $057660876488de6d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $057660876488de6d$var$load("2YffH"),
    $057660876488de6d$var$load("8Kivm"),
    $057660876488de6d$var$load("cf5vC"),
    $057660876488de6d$var$load("A1eSR"),
    $057660876488de6d$var$load("2rCak"),
    $057660876488de6d$var$load("iQ0Jm"),
    $057660876488de6d$var$load("coJiW"),
    $057660876488de6d$var$load("eYere"),
    $057660876488de6d$var$load("at1W4"),
    $057660876488de6d$var$load("h4Nf7"),
    $057660876488de6d$var$load("7f9Fz"),
    $057660876488de6d$var$load("8YSo7"),
    $057660876488de6d$var$load("fqGSw"),
    $057660876488de6d$var$load("2Cftu"),
    $057660876488de6d$var$load("4i0CB"),
    $057660876488de6d$var$load("g9CVe"),
    $057660876488de6d$var$load("49GA1"),
    $057660876488de6d$var$load("32K9i"),
    $057660876488de6d$var$load("aeEUI"),
    $057660876488de6d$var$load("iXzmH"),
    $057660876488de6d$var$load("65c4i"),
    $057660876488de6d$var$load("6wr18"),
    $057660876488de6d$var$load("kjZZD"),
    $057660876488de6d$var$load("3TTZL"),
    $057660876488de6d$var$load("37ldp"),
    $057660876488de6d$var$load("jkPqm"),
    $057660876488de6d$var$load("awqCy"),
    $057660876488de6d$var$load("kHOMt"),
    $057660876488de6d$var$load("hhss7"),
    $057660876488de6d$var$load("ePdWC"),
    $057660876488de6d$var$load("lBzRN"),
    $057660876488de6d$var$load("9wxKg"),
    $057660876488de6d$var$load("Wowvf"),
    $057660876488de6d$var$load("6O8m6"),
    $057660876488de6d$var$load("5GxU8"),
    $057660876488de6d$var$load("7whwt"),
    $057660876488de6d$var$load("699ae"),
    $057660876488de6d$var$load("i7QCq"),
    $057660876488de6d$var$load("let0D"),
    $057660876488de6d$var$load("87NBA"),
    $057660876488de6d$var$load("6M36W"),
    $057660876488de6d$var$load("ffEVr"),
    $057660876488de6d$var$load("kUbUu"),
    $057660876488de6d$var$load("9ftJe"),
    $057660876488de6d$var$load("hUIij"),
    $057660876488de6d$var$load("6Up0b"),
    $057660876488de6d$var$load("lnKog"),
    $057660876488de6d$var$load("7Omhy"),
    $057660876488de6d$var$load("kC80R"),
    $057660876488de6d$var$load("7EorR"),
    $057660876488de6d$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("5tnh5", function(module, exports) {

let $3fc1b7061bc3a278$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3fc1b7061bc3a278$var$load("2YffH"),
    $3fc1b7061bc3a278$var$load("cf5vC"),
    $3fc1b7061bc3a278$var$load("A1eSR"),
    $3fc1b7061bc3a278$var$load("2rCak"),
    $3fc1b7061bc3a278$var$load("eYere"),
    $3fc1b7061bc3a278$var$load("at1W4"),
    $3fc1b7061bc3a278$var$load("h4Nf7"),
    $3fc1b7061bc3a278$var$load("7f9Fz"),
    $3fc1b7061bc3a278$var$load("8YSo7"),
    $3fc1b7061bc3a278$var$load("fqGSw"),
    $3fc1b7061bc3a278$var$load("g9CVe"),
    $3fc1b7061bc3a278$var$load("49GA1"),
    $3fc1b7061bc3a278$var$load("32K9i"),
    $3fc1b7061bc3a278$var$load("aeEUI"),
    $3fc1b7061bc3a278$var$load("iXzmH"),
    $3fc1b7061bc3a278$var$load("65c4i"),
    $3fc1b7061bc3a278$var$load("6wr18"),
    $3fc1b7061bc3a278$var$load("kjZZD"),
    $3fc1b7061bc3a278$var$load("3TTZL"),
    $3fc1b7061bc3a278$var$load("37ldp"),
    $3fc1b7061bc3a278$var$load("jkPqm"),
    $3fc1b7061bc3a278$var$load("awqCy"),
    $3fc1b7061bc3a278$var$load("kHOMt"),
    $3fc1b7061bc3a278$var$load("hhss7"),
    $3fc1b7061bc3a278$var$load("ePdWC"),
    $3fc1b7061bc3a278$var$load("lBzRN"),
    $3fc1b7061bc3a278$var$load("9wxKg"),
    $3fc1b7061bc3a278$var$load("Wowvf"),
    $3fc1b7061bc3a278$var$load("6O8m6"),
    $3fc1b7061bc3a278$var$load("5GxU8"),
    $3fc1b7061bc3a278$var$load("7whwt"),
    $3fc1b7061bc3a278$var$load("699ae"),
    $3fc1b7061bc3a278$var$load("i7QCq"),
    $3fc1b7061bc3a278$var$load("let0D"),
    $3fc1b7061bc3a278$var$load("87NBA"),
    $3fc1b7061bc3a278$var$load("6M36W"),
    $3fc1b7061bc3a278$var$load("hUIij"),
    $3fc1b7061bc3a278$var$load("ffEVr"),
    $3fc1b7061bc3a278$var$load("kUbUu"),
    $3fc1b7061bc3a278$var$load("9ftJe"),
    $3fc1b7061bc3a278$var$load("7Omhy"),
    $3fc1b7061bc3a278$var$load("kC80R"),
    $3fc1b7061bc3a278$var$load("7EorR"),
    $3fc1b7061bc3a278$var$load("68RC4")
]).then(()=>parcelRequire('f6dwD'));

});

parcelRegister("7359q", function(module, exports) {

let $521ccf1bbaa68bb0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $521ccf1bbaa68bb0$var$load("2YffH"),
    $521ccf1bbaa68bb0$var$load("cf5vC"),
    $521ccf1bbaa68bb0$var$load("A1eSR"),
    $521ccf1bbaa68bb0$var$load("2rCak"),
    $521ccf1bbaa68bb0$var$load("eYere"),
    $521ccf1bbaa68bb0$var$load("at1W4"),
    $521ccf1bbaa68bb0$var$load("h4Nf7"),
    $521ccf1bbaa68bb0$var$load("7f9Fz"),
    $521ccf1bbaa68bb0$var$load("8YSo7"),
    $521ccf1bbaa68bb0$var$load("fqGSw"),
    $521ccf1bbaa68bb0$var$load("g9CVe"),
    $521ccf1bbaa68bb0$var$load("49GA1"),
    $521ccf1bbaa68bb0$var$load("32K9i"),
    $521ccf1bbaa68bb0$var$load("aeEUI"),
    $521ccf1bbaa68bb0$var$load("iXzmH"),
    $521ccf1bbaa68bb0$var$load("65c4i"),
    $521ccf1bbaa68bb0$var$load("6wr18"),
    $521ccf1bbaa68bb0$var$load("kjZZD"),
    $521ccf1bbaa68bb0$var$load("3TTZL"),
    $521ccf1bbaa68bb0$var$load("37ldp"),
    $521ccf1bbaa68bb0$var$load("jkPqm"),
    $521ccf1bbaa68bb0$var$load("awqCy"),
    $521ccf1bbaa68bb0$var$load("kHOMt"),
    $521ccf1bbaa68bb0$var$load("hhss7"),
    $521ccf1bbaa68bb0$var$load("ePdWC"),
    $521ccf1bbaa68bb0$var$load("lBzRN"),
    $521ccf1bbaa68bb0$var$load("9wxKg"),
    $521ccf1bbaa68bb0$var$load("Wowvf"),
    $521ccf1bbaa68bb0$var$load("6O8m6"),
    $521ccf1bbaa68bb0$var$load("5GxU8"),
    $521ccf1bbaa68bb0$var$load("7whwt"),
    $521ccf1bbaa68bb0$var$load("699ae"),
    $521ccf1bbaa68bb0$var$load("i7QCq"),
    $521ccf1bbaa68bb0$var$load("let0D"),
    $521ccf1bbaa68bb0$var$load("87NBA"),
    $521ccf1bbaa68bb0$var$load("6M36W"),
    $521ccf1bbaa68bb0$var$load("hUIij"),
    $521ccf1bbaa68bb0$var$load("ffEVr"),
    $521ccf1bbaa68bb0$var$load("kUbUu"),
    $521ccf1bbaa68bb0$var$load("9ftJe"),
    $521ccf1bbaa68bb0$var$load("7Omhy"),
    $521ccf1bbaa68bb0$var$load("kC80R"),
    $521ccf1bbaa68bb0$var$load("7EorR"),
    $521ccf1bbaa68bb0$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("eDY8d", function(module, exports) {

let $aa935a165b9f0b4d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $aa935a165b9f0b4d$var$load("2YffH"),
    $aa935a165b9f0b4d$var$load("cf5vC"),
    $aa935a165b9f0b4d$var$load("A1eSR"),
    $aa935a165b9f0b4d$var$load("2rCak"),
    $aa935a165b9f0b4d$var$load("eYere"),
    $aa935a165b9f0b4d$var$load("at1W4"),
    $aa935a165b9f0b4d$var$load("h4Nf7"),
    $aa935a165b9f0b4d$var$load("7f9Fz"),
    $aa935a165b9f0b4d$var$load("8YSo7"),
    $aa935a165b9f0b4d$var$load("fqGSw"),
    $aa935a165b9f0b4d$var$load("g9CVe"),
    $aa935a165b9f0b4d$var$load("49GA1"),
    $aa935a165b9f0b4d$var$load("32K9i"),
    $aa935a165b9f0b4d$var$load("aeEUI"),
    $aa935a165b9f0b4d$var$load("iXzmH"),
    $aa935a165b9f0b4d$var$load("65c4i"),
    $aa935a165b9f0b4d$var$load("6wr18"),
    $aa935a165b9f0b4d$var$load("kjZZD"),
    $aa935a165b9f0b4d$var$load("3TTZL"),
    $aa935a165b9f0b4d$var$load("37ldp"),
    $aa935a165b9f0b4d$var$load("jkPqm"),
    $aa935a165b9f0b4d$var$load("awqCy"),
    $aa935a165b9f0b4d$var$load("kHOMt"),
    $aa935a165b9f0b4d$var$load("hhss7"),
    $aa935a165b9f0b4d$var$load("ePdWC"),
    $aa935a165b9f0b4d$var$load("lBzRN"),
    $aa935a165b9f0b4d$var$load("9wxKg"),
    $aa935a165b9f0b4d$var$load("Wowvf"),
    $aa935a165b9f0b4d$var$load("6O8m6"),
    $aa935a165b9f0b4d$var$load("5GxU8"),
    $aa935a165b9f0b4d$var$load("7whwt"),
    $aa935a165b9f0b4d$var$load("699ae"),
    $aa935a165b9f0b4d$var$load("i7QCq"),
    $aa935a165b9f0b4d$var$load("let0D"),
    $aa935a165b9f0b4d$var$load("87NBA"),
    $aa935a165b9f0b4d$var$load("6M36W"),
    $aa935a165b9f0b4d$var$load("hUIij"),
    $aa935a165b9f0b4d$var$load("ffEVr"),
    $aa935a165b9f0b4d$var$load("kUbUu"),
    $aa935a165b9f0b4d$var$load("9ftJe"),
    $aa935a165b9f0b4d$var$load("7Omhy"),
    $aa935a165b9f0b4d$var$load("kC80R"),
    $aa935a165b9f0b4d$var$load("7EorR"),
    $aa935a165b9f0b4d$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("jKQL4", function(module, exports) {

let $e61b3cdcf894c8d2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e61b3cdcf894c8d2$var$load("2YffH"),
    $e61b3cdcf894c8d2$var$load("cf5vC"),
    $e61b3cdcf894c8d2$var$load("A1eSR"),
    $e61b3cdcf894c8d2$var$load("2rCak"),
    $e61b3cdcf894c8d2$var$load("eYere"),
    $e61b3cdcf894c8d2$var$load("at1W4"),
    $e61b3cdcf894c8d2$var$load("h4Nf7"),
    $e61b3cdcf894c8d2$var$load("7f9Fz"),
    $e61b3cdcf894c8d2$var$load("8YSo7"),
    $e61b3cdcf894c8d2$var$load("fqGSw"),
    $e61b3cdcf894c8d2$var$load("g9CVe"),
    $e61b3cdcf894c8d2$var$load("49GA1"),
    $e61b3cdcf894c8d2$var$load("32K9i"),
    $e61b3cdcf894c8d2$var$load("aeEUI"),
    $e61b3cdcf894c8d2$var$load("iXzmH"),
    $e61b3cdcf894c8d2$var$load("65c4i"),
    $e61b3cdcf894c8d2$var$load("6wr18"),
    $e61b3cdcf894c8d2$var$load("kjZZD"),
    $e61b3cdcf894c8d2$var$load("3TTZL"),
    $e61b3cdcf894c8d2$var$load("37ldp"),
    $e61b3cdcf894c8d2$var$load("jkPqm"),
    $e61b3cdcf894c8d2$var$load("awqCy"),
    $e61b3cdcf894c8d2$var$load("kHOMt"),
    $e61b3cdcf894c8d2$var$load("hhss7"),
    $e61b3cdcf894c8d2$var$load("ePdWC"),
    $e61b3cdcf894c8d2$var$load("lBzRN"),
    $e61b3cdcf894c8d2$var$load("9wxKg"),
    $e61b3cdcf894c8d2$var$load("Wowvf"),
    $e61b3cdcf894c8d2$var$load("6O8m6"),
    $e61b3cdcf894c8d2$var$load("5GxU8"),
    $e61b3cdcf894c8d2$var$load("7whwt"),
    $e61b3cdcf894c8d2$var$load("699ae"),
    $e61b3cdcf894c8d2$var$load("i7QCq"),
    $e61b3cdcf894c8d2$var$load("let0D"),
    $e61b3cdcf894c8d2$var$load("87NBA"),
    $e61b3cdcf894c8d2$var$load("6M36W"),
    $e61b3cdcf894c8d2$var$load("ffEVr"),
    $e61b3cdcf894c8d2$var$load("kUbUu"),
    $e61b3cdcf894c8d2$var$load("9ftJe"),
    $e61b3cdcf894c8d2$var$load("hUIij"),
    $e61b3cdcf894c8d2$var$load("6Up0b"),
    $e61b3cdcf894c8d2$var$load("lnKog"),
    $e61b3cdcf894c8d2$var$load("7Omhy"),
    $e61b3cdcf894c8d2$var$load("kC80R"),
    $e61b3cdcf894c8d2$var$load("7EorR"),
    $e61b3cdcf894c8d2$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("89h6z", function(module, exports) {

let $5eec6eab9fc33990$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5eec6eab9fc33990$var$load("2YffH"),
    $5eec6eab9fc33990$var$load("cf5vC"),
    $5eec6eab9fc33990$var$load("A1eSR"),
    $5eec6eab9fc33990$var$load("2rCak"),
    $5eec6eab9fc33990$var$load("coJiW"),
    $5eec6eab9fc33990$var$load("eYere"),
    $5eec6eab9fc33990$var$load("at1W4"),
    $5eec6eab9fc33990$var$load("h4Nf7"),
    $5eec6eab9fc33990$var$load("7f9Fz"),
    $5eec6eab9fc33990$var$load("8YSo7"),
    $5eec6eab9fc33990$var$load("fqGSw"),
    $5eec6eab9fc33990$var$load("2Cftu"),
    $5eec6eab9fc33990$var$load("4i0CB"),
    $5eec6eab9fc33990$var$load("g9CVe"),
    $5eec6eab9fc33990$var$load("49GA1"),
    $5eec6eab9fc33990$var$load("32K9i"),
    $5eec6eab9fc33990$var$load("aeEUI"),
    $5eec6eab9fc33990$var$load("iXzmH"),
    $5eec6eab9fc33990$var$load("65c4i"),
    $5eec6eab9fc33990$var$load("6wr18"),
    $5eec6eab9fc33990$var$load("kjZZD"),
    $5eec6eab9fc33990$var$load("3TTZL"),
    $5eec6eab9fc33990$var$load("37ldp"),
    $5eec6eab9fc33990$var$load("jkPqm"),
    $5eec6eab9fc33990$var$load("dTsOE"),
    $5eec6eab9fc33990$var$load("awqCy"),
    $5eec6eab9fc33990$var$load("kHOMt"),
    $5eec6eab9fc33990$var$load("hhss7"),
    $5eec6eab9fc33990$var$load("ePdWC"),
    $5eec6eab9fc33990$var$load("lBzRN"),
    $5eec6eab9fc33990$var$load("9wxKg"),
    $5eec6eab9fc33990$var$load("Wowvf"),
    $5eec6eab9fc33990$var$load("6O8m6"),
    $5eec6eab9fc33990$var$load("5GxU8"),
    $5eec6eab9fc33990$var$load("7whwt"),
    $5eec6eab9fc33990$var$load("699ae"),
    $5eec6eab9fc33990$var$load("i7QCq"),
    $5eec6eab9fc33990$var$load("let0D"),
    $5eec6eab9fc33990$var$load("87NBA"),
    $5eec6eab9fc33990$var$load("6M36W"),
    $5eec6eab9fc33990$var$load("ffEVr"),
    $5eec6eab9fc33990$var$load("kUbUu"),
    $5eec6eab9fc33990$var$load("9ftJe"),
    $5eec6eab9fc33990$var$load("hUIij"),
    $5eec6eab9fc33990$var$load("6Up0b"),
    $5eec6eab9fc33990$var$load("lnKog"),
    $5eec6eab9fc33990$var$load("7Omhy"),
    $5eec6eab9fc33990$var$load("kC80R"),
    $5eec6eab9fc33990$var$load("7EorR"),
    $5eec6eab9fc33990$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("aVgUi", function(module, exports) {

let $7f3c57a6e282232e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7f3c57a6e282232e$var$load("2YffH"),
    $7f3c57a6e282232e$var$load("cf5vC"),
    $7f3c57a6e282232e$var$load("A1eSR"),
    $7f3c57a6e282232e$var$load("2rCak"),
    $7f3c57a6e282232e$var$load("coJiW"),
    $7f3c57a6e282232e$var$load("eYere"),
    $7f3c57a6e282232e$var$load("at1W4"),
    $7f3c57a6e282232e$var$load("h4Nf7"),
    $7f3c57a6e282232e$var$load("7f9Fz"),
    $7f3c57a6e282232e$var$load("8YSo7"),
    $7f3c57a6e282232e$var$load("fqGSw"),
    $7f3c57a6e282232e$var$load("2Cftu"),
    $7f3c57a6e282232e$var$load("4i0CB"),
    $7f3c57a6e282232e$var$load("g9CVe"),
    $7f3c57a6e282232e$var$load("49GA1"),
    $7f3c57a6e282232e$var$load("32K9i"),
    $7f3c57a6e282232e$var$load("aeEUI"),
    $7f3c57a6e282232e$var$load("iXzmH"),
    $7f3c57a6e282232e$var$load("65c4i"),
    $7f3c57a6e282232e$var$load("6wr18"),
    $7f3c57a6e282232e$var$load("kjZZD"),
    $7f3c57a6e282232e$var$load("3TTZL"),
    $7f3c57a6e282232e$var$load("37ldp"),
    $7f3c57a6e282232e$var$load("jkPqm"),
    $7f3c57a6e282232e$var$load("dTsOE"),
    $7f3c57a6e282232e$var$load("awqCy"),
    $7f3c57a6e282232e$var$load("kHOMt"),
    $7f3c57a6e282232e$var$load("hhss7"),
    $7f3c57a6e282232e$var$load("ePdWC"),
    $7f3c57a6e282232e$var$load("lBzRN"),
    $7f3c57a6e282232e$var$load("9wxKg"),
    $7f3c57a6e282232e$var$load("Wowvf"),
    $7f3c57a6e282232e$var$load("6O8m6"),
    $7f3c57a6e282232e$var$load("5GxU8"),
    $7f3c57a6e282232e$var$load("7whwt"),
    $7f3c57a6e282232e$var$load("699ae"),
    $7f3c57a6e282232e$var$load("i7QCq"),
    $7f3c57a6e282232e$var$load("let0D"),
    $7f3c57a6e282232e$var$load("87NBA"),
    $7f3c57a6e282232e$var$load("6M36W"),
    $7f3c57a6e282232e$var$load("ffEVr"),
    $7f3c57a6e282232e$var$load("kUbUu"),
    $7f3c57a6e282232e$var$load("9ftJe"),
    $7f3c57a6e282232e$var$load("hUIij"),
    $7f3c57a6e282232e$var$load("6Up0b"),
    $7f3c57a6e282232e$var$load("lnKog"),
    $7f3c57a6e282232e$var$load("7Omhy"),
    $7f3c57a6e282232e$var$load("kC80R"),
    $7f3c57a6e282232e$var$load("7EorR"),
    $7f3c57a6e282232e$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("jLqFe", function(module, exports) {

let $e637170b68f7e010$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e637170b68f7e010$var$load("2YffH"),
    $e637170b68f7e010$var$load("cf5vC"),
    $e637170b68f7e010$var$load("A1eSR"),
    $e637170b68f7e010$var$load("2rCak"),
    $e637170b68f7e010$var$load("eYere"),
    $e637170b68f7e010$var$load("at1W4"),
    $e637170b68f7e010$var$load("h4Nf7"),
    $e637170b68f7e010$var$load("7f9Fz"),
    $e637170b68f7e010$var$load("8YSo7"),
    $e637170b68f7e010$var$load("fqGSw"),
    $e637170b68f7e010$var$load("g9CVe"),
    $e637170b68f7e010$var$load("49GA1"),
    $e637170b68f7e010$var$load("32K9i"),
    $e637170b68f7e010$var$load("aeEUI"),
    $e637170b68f7e010$var$load("iXzmH"),
    $e637170b68f7e010$var$load("65c4i"),
    $e637170b68f7e010$var$load("6wr18"),
    $e637170b68f7e010$var$load("kjZZD"),
    $e637170b68f7e010$var$load("3TTZL"),
    $e637170b68f7e010$var$load("37ldp"),
    $e637170b68f7e010$var$load("jkPqm"),
    $e637170b68f7e010$var$load("awqCy"),
    $e637170b68f7e010$var$load("kHOMt"),
    $e637170b68f7e010$var$load("hhss7"),
    $e637170b68f7e010$var$load("ePdWC"),
    $e637170b68f7e010$var$load("lBzRN"),
    $e637170b68f7e010$var$load("9wxKg"),
    $e637170b68f7e010$var$load("Wowvf"),
    $e637170b68f7e010$var$load("6O8m6"),
    $e637170b68f7e010$var$load("5GxU8"),
    $e637170b68f7e010$var$load("7whwt"),
    $e637170b68f7e010$var$load("699ae"),
    $e637170b68f7e010$var$load("i7QCq"),
    $e637170b68f7e010$var$load("let0D"),
    $e637170b68f7e010$var$load("87NBA"),
    $e637170b68f7e010$var$load("6M36W"),
    $e637170b68f7e010$var$load("hUIij"),
    $e637170b68f7e010$var$load("ffEVr"),
    $e637170b68f7e010$var$load("kUbUu"),
    $e637170b68f7e010$var$load("9ftJe"),
    $e637170b68f7e010$var$load("7Omhy"),
    $e637170b68f7e010$var$load("kC80R"),
    $e637170b68f7e010$var$load("7EorR"),
    $e637170b68f7e010$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("gdpl8", function(module, exports) {

let $bce1843c91130187$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bce1843c91130187$var$load("2YffH"),
    $bce1843c91130187$var$load("cf5vC"),
    $bce1843c91130187$var$load("A1eSR"),
    $bce1843c91130187$var$load("2rCak"),
    $bce1843c91130187$var$load("eYere"),
    $bce1843c91130187$var$load("at1W4"),
    $bce1843c91130187$var$load("h4Nf7"),
    $bce1843c91130187$var$load("7f9Fz"),
    $bce1843c91130187$var$load("8YSo7"),
    $bce1843c91130187$var$load("fqGSw"),
    $bce1843c91130187$var$load("g9CVe"),
    $bce1843c91130187$var$load("49GA1"),
    $bce1843c91130187$var$load("32K9i"),
    $bce1843c91130187$var$load("aeEUI"),
    $bce1843c91130187$var$load("iXzmH"),
    $bce1843c91130187$var$load("65c4i"),
    $bce1843c91130187$var$load("6wr18"),
    $bce1843c91130187$var$load("kjZZD"),
    $bce1843c91130187$var$load("3TTZL"),
    $bce1843c91130187$var$load("37ldp"),
    $bce1843c91130187$var$load("jkPqm"),
    $bce1843c91130187$var$load("awqCy"),
    $bce1843c91130187$var$load("kHOMt"),
    $bce1843c91130187$var$load("hhss7"),
    $bce1843c91130187$var$load("ePdWC"),
    $bce1843c91130187$var$load("lBzRN"),
    $bce1843c91130187$var$load("9wxKg"),
    $bce1843c91130187$var$load("Wowvf"),
    $bce1843c91130187$var$load("6O8m6"),
    $bce1843c91130187$var$load("5GxU8"),
    $bce1843c91130187$var$load("7whwt"),
    $bce1843c91130187$var$load("699ae"),
    $bce1843c91130187$var$load("i7QCq"),
    $bce1843c91130187$var$load("let0D"),
    $bce1843c91130187$var$load("87NBA"),
    $bce1843c91130187$var$load("6M36W"),
    $bce1843c91130187$var$load("ffEVr"),
    $bce1843c91130187$var$load("kUbUu"),
    $bce1843c91130187$var$load("9ftJe"),
    $bce1843c91130187$var$load("hUIij"),
    $bce1843c91130187$var$load("6Up0b"),
    $bce1843c91130187$var$load("lnKog"),
    $bce1843c91130187$var$load("7Omhy"),
    $bce1843c91130187$var$load("kC80R"),
    $bce1843c91130187$var$load("7EorR"),
    $bce1843c91130187$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("4bplr", function(module, exports) {

let $30bbd978491ced0e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $30bbd978491ced0e$var$load("2YffH"),
    $30bbd978491ced0e$var$load("cf5vC"),
    $30bbd978491ced0e$var$load("A1eSR"),
    $30bbd978491ced0e$var$load("2rCak"),
    $30bbd978491ced0e$var$load("eYere"),
    $30bbd978491ced0e$var$load("at1W4"),
    $30bbd978491ced0e$var$load("h4Nf7"),
    $30bbd978491ced0e$var$load("7f9Fz"),
    $30bbd978491ced0e$var$load("8YSo7"),
    $30bbd978491ced0e$var$load("fqGSw"),
    $30bbd978491ced0e$var$load("g9CVe"),
    $30bbd978491ced0e$var$load("49GA1"),
    $30bbd978491ced0e$var$load("32K9i"),
    $30bbd978491ced0e$var$load("aeEUI"),
    $30bbd978491ced0e$var$load("iXzmH"),
    $30bbd978491ced0e$var$load("65c4i"),
    $30bbd978491ced0e$var$load("6wr18"),
    $30bbd978491ced0e$var$load("kjZZD"),
    $30bbd978491ced0e$var$load("3TTZL"),
    $30bbd978491ced0e$var$load("37ldp"),
    $30bbd978491ced0e$var$load("jkPqm"),
    $30bbd978491ced0e$var$load("awqCy"),
    $30bbd978491ced0e$var$load("kHOMt"),
    $30bbd978491ced0e$var$load("hhss7"),
    $30bbd978491ced0e$var$load("ePdWC"),
    $30bbd978491ced0e$var$load("lBzRN"),
    $30bbd978491ced0e$var$load("9wxKg"),
    $30bbd978491ced0e$var$load("Wowvf"),
    $30bbd978491ced0e$var$load("6O8m6"),
    $30bbd978491ced0e$var$load("5GxU8"),
    $30bbd978491ced0e$var$load("7whwt"),
    $30bbd978491ced0e$var$load("699ae"),
    $30bbd978491ced0e$var$load("i7QCq"),
    $30bbd978491ced0e$var$load("let0D"),
    $30bbd978491ced0e$var$load("87NBA"),
    $30bbd978491ced0e$var$load("6M36W"),
    $30bbd978491ced0e$var$load("ffEVr"),
    $30bbd978491ced0e$var$load("kUbUu"),
    $30bbd978491ced0e$var$load("9ftJe"),
    $30bbd978491ced0e$var$load("hUIij"),
    $30bbd978491ced0e$var$load("6Up0b"),
    $30bbd978491ced0e$var$load("lnKog"),
    $30bbd978491ced0e$var$load("7Omhy"),
    $30bbd978491ced0e$var$load("kC80R"),
    $30bbd978491ced0e$var$load("7EorR"),
    $30bbd978491ced0e$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});

parcelRegister("hIaUw", function(module, exports) {
const $5ff3d548ffdc5eda$export$1ef77878e4e0b972 = (routeName)=>{
    if (routeName?.includes('PAGE')) return 'page';
    if (routeName?.includes('BLOG')) return 'blogpost';
    if (routeName?.includes('SPACE')) return 'space';
    return 'page';
};
module.exports["getContentType"] = $5ff3d548ffdc5eda$export$1ef77878e4e0b972;

});

parcelRegister("8a9Dm", function(module, exports) {
const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
const $2cc1b73219e08564$export$d3ac53161a36a310 = (forgeData)=>{
    const extensionContext = forgeData?.extensionContexts?.[0];
    if (!extensionContext) return [];
    if (extensionContext.hasOwnProperty('extensions')) return extensionContext.extensions;
    if (extensionContext.hasOwnProperty('extensionsByType')) return extensionContext.extensionsByType;
    return [];
};
module.exports["getAppId"] = $2cc1b73219e08564$export$fb2283f4a44fb53;
module.exports["getModuleKey"] = $2cc1b73219e08564$export$b17b21a48c0a3273;
module.exports["getCustomContentType"] = $2cc1b73219e08564$export$9eb690901638fb96;

});

parcelRegister("dizL5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $55b20ed34f146485$export$350b371bfb7f5e95 = (loadingComponent)=>(0, $jmjWc.LoadableAfterPaint)({
        __loadable_id__: "UJdch",
        name: "lazyForgeUIExtensionsWithLoader",
        loader: async ()=>(await (parcelRequire("dVFAI"))).ForgeUIExtensionsWrapper,
        loading: loadingComponent
    });
const $55b20ed34f146485$export$4cbc6d03d50a8849 = $55b20ed34f146485$export$350b371bfb7f5e95(undefined);
module.exports["lazyForgeUIExtensionsWithLoader"] = $55b20ed34f146485$export$350b371bfb7f5e95;
module.exports["LazyForgeUIExtensions"] = $55b20ed34f146485$export$4cbc6d03d50a8849;

});

parcelRegister("dVFAI", function(module, exports) {

let $a240dc5be70b389e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a240dc5be70b389e$var$load("hUIij"),
    $a240dc5be70b389e$var$load("6Up0b"),
    $a240dc5be70b389e$var$load("lnKog")
]).then(()=>parcelRequire('2mcHd'));

});

parcelRegister("6UqI3", function(module, exports) {
const $a3c7cd489159fe33$export$28eddf802cd184f7 = (spaceKey)=>{
    return spaceKey?.[0] === '~' ? 'personal' : 'global';
};
module.exports["getSpaceType"] = $a3c7cd489159fe33$export$28eddf802cd184f7;

});

parcelRegister("c54hr", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $367766f6f044c46b$var$initialState = {
    isMenuOpen: false,
    isCloseMenuDisabled: false
};
const $367766f6f044c46b$var$actions = {
    setIsMenuOpen: (isMenuOpen)=>({ setState: setState })=>{
            setState({
                isMenuOpen: isMenuOpen
            });
        },
    setIsCloseMenuDisabled: (isCloseMenuDisabled)=>({ setState: setState })=>{
            setState({
                isCloseMenuDisabled: isCloseMenuDisabled
            });
        }
};
const $367766f6f044c46b$var$Store = (0, $1P1Tu.createStore)({
    initialState: $367766f6f044c46b$var$initialState,
    actions: $367766f6f044c46b$var$actions,
    name: 'more-actions-menu-store'
});
const $367766f6f044c46b$export$14d00db016c2b3ef = (0, $9zUhf.createStateHook)($367766f6f044c46b$var$Store);
const $367766f6f044c46b$export$1f1f8c486fa8a1cb = (0, $9zUhf.createActionsHook)($367766f6f044c46b$var$Store);
module.exports["useMoreActionsMenuState"] = $367766f6f044c46b$export$14d00db016c2b3ef;
module.exports["useMoreActionsMenuActions"] = $367766f6f044c46b$export$1f1f8c486fa8a1cb;

});

parcelRegister("9fBoq", function(module, exports) {
parcelRequire("1c598");
var $1Aku8 = parcelRequire("1Aku8");

const $6ca0453d93f30f16$var$capitalize = (str)=>{
    if (!str || !str.length) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
const $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e = (extension, overriddenTitle)=>{
    const title = overriddenTitle || extension.properties.title;
    const { environmentType: environmentType, environmentKey: environmentKey } = extension;
    if (environmentType === (0, $1Aku8.ProductEnvironment).PRODUCTION) return title;
    if (environmentType === (0, $1Aku8.ProductEnvironment).DEVELOPMENT && environmentKey !== 'default') return `${title} - ${environmentKey} (Dev)`;
    return `${title} (${$6ca0453d93f30f16$var$capitalize(environmentType)})`;
};
module.exports["extensionTitle"] = $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e;

});

parcelRegister("1c598", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);
parcelRequire("i3Ypo");
var $2JC3k = parcelRequire("2JC3k");
var $1Aku8 = parcelRequire("1Aku8");
var $9dbGT = parcelRequire("9dbGT");

parcelRequire("jUCNB");
var $gUjm2 = parcelRequire("gUjm2");
var $kg3OT = parcelRequire("kg3OT");
var $fsQJy = parcelRequire("fsQJy");


});

parcelRegister("i3Ypo", function(module, exports) {
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);

var $9dbGT = parcelRequire("9dbGT");


var $1Aku8 = parcelRequire("1Aku8");


var $6sM2K = parcelRequire("6sM2K");


var $2JC3k = parcelRequire("2JC3k");


});

parcelRegister("9dbGT", function(module, exports) {
const $1ec3e8240f57817b$export$3b98ab6402702476 = [
    'Em',
    'Link',
    'Strike',
    'String',
    'Strong',
    'User'
];
const $1ec3e8240f57817b$export$3ee8c58bb87b9685 = [
    ...$1ec3e8240f57817b$export$3b98ab6402702476,
    'Badge',
    'Code',
    'DateLozenge',
    'StatusLozenge',
    'Tag',
    'UserGroup'
];
module.exports["MarkupRecursiveList"] = $1ec3e8240f57817b$export$3b98ab6402702476;
module.exports["MarkupList"] = $1ec3e8240f57817b$export$3ee8c58bb87b9685;

});

parcelRegister("1Aku8", function(module, exports) {
var $d128cc36ec70c56c$export$2688cec3c24cb60b = /*#__PURE__*/ function(ProductEnvironment) {
    ProductEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ProductEnvironment["STAGING"] = "STAGING";
    ProductEnvironment["PRODUCTION"] = "PRODUCTION";
    return ProductEnvironment;
}({});
var $d128cc36ec70c56c$export$beaef1891b3e7ca3 = /*#__PURE__*/ function(ForgeCDNEnvironment) {
    ForgeCDNEnvironment["DEVELOPMENT"] = "dev";
    ForgeCDNEnvironment["STAGING"] = "stg";
    ForgeCDNEnvironment["PRODUCTION"] = "prod";
    return ForgeCDNEnvironment;
}({});
module.exports["ProductEnvironment"] = $d128cc36ec70c56c$export$2688cec3c24cb60b;
module.exports["ForgeCDNEnvironment"] = $d128cc36ec70c56c$export$beaef1891b3e7ca3;

});

parcelRegister("6sM2K", function(module, exports) {
const $0e3337cb4407ef3b$export$21b318cfdd670495 = (error)=>({
        type: 'render',
        aux: {
            type: 'View',
            children: [
                {
                    type: 'ErrorPanel',
                    props: {
                        error: error
                    },
                    children: []
                }
            ]
        },
        state: {}
    });

});

parcelRegister("2JC3k", function(module, exports) {
var $d977f97374f9d2c9$export$6e95f5308d9156f9 = /*#__PURE__*/ function(ExtensionEnvironment) {
    ExtensionEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ExtensionEnvironment["STAGING"] = "STAGING";
    ExtensionEnvironment["PRODUCTION"] = "PRODUCTION";
    return ExtensionEnvironment;
}({});
const $d977f97374f9d2c9$export$9a2372818e2520c6 = {
    BYLINE: 'confluence:contentBylineItem',
    CONTEXT_MENU: 'confluence:contextMenu',
    CONTENT_ACTION: 'confluence:contentAction',
    GLOBAL_PAGE: 'confluence:globalPage',
    GLOBAL_SETTINGS: 'confluence:globalSettings',
    HOMEPAGE_FEED: 'confluence:homepageFeed',
    SPACE_PAGE: 'confluence:spacePage',
    SPACE_SETTINGS: 'confluence:spaceSettings',
    CUSTOM_CONTENT: 'confluence:customContent',
    TEST_MODULE: 'test:module'
};
const $d977f97374f9d2c9$export$f06ffa3aa6bfec95 = {
    BACKLOG_ACTION: 'jira:backlogAction',
    BOARD_ACTION: 'jira:boardAction',
    PERSONAL_SETTINGS_PAGE: 'jira:personalSettingsPage',
    ISSUE_PANEL: 'jira:issuePanel',
    ISSUE_ACTION: 'jira:issueAction',
    ISSUE_GLANCE: 'jira:issueGlance',
    ISSUE_CONTEXT: 'jira:issueContext',
    ISSUE_ACTIVITY: 'jira:issueActivity',
    UI_MODIFICATIONS: 'jira:uiModifications',
    CUSTOM_FIELD: 'jira:customField',
    CUSTOM_FIELD_TYPE: 'jira:customFieldType',
    ADMIN_PAGE: 'jira:adminPage',
    GLOBAL_PAGE: 'jira:globalPage',
    PROJECT_PAGE: 'jira:projectPage',
    PROJECT_SETTINGS_PAGE: 'jira:projectSettingsPage',
    DASHBOARD_BACKGROUND_SCRIPT: 'jira:dashboardBackgroundScript',
    ISSUE_VIEW_BACKGROUND_SCRIPT: 'jira:issueViewBackgroundScript',
    DASHBOARD_GADGET: 'jira:dashboardGadget',
    WORKFLOW_VALIDATOR: 'jira:workflowValidator',
    WORKFLOW_CONDITION: 'jira:workflowCondition',
    WORKFLOW_POST_FUNCTION: 'jira:workflowPostFunction',
    SERVICE_DESK_QUEUE_PAGE: 'jiraServiceManagement:queuePage',
    SERVICE_DESK_ORGANIZATION_PANEL: 'jiraServiceManagement:organizationPanel'
};
module.exports["ExtensionEnvironment"] = $d977f97374f9d2c9$export$6e95f5308d9156f9;
module.exports["ConfluenceExtension"] = $d977f97374f9d2c9$export$9a2372818e2520c6;
module.exports["JiraExtension"] = $d977f97374f9d2c9$export$f06ffa3aa6bfec95;

});

parcelRegister("jUCNB", function(module, exports) {

var $fsQJy = parcelRequire("fsQJy");


var $kg3OT = parcelRequire("kg3OT");


var $gUjm2 = parcelRequire("gUjm2");


});

parcelRegister("fsQJy", function(module, exports) {
// DELETE FILE http://go/j/FUI-1091
const $8d78496ee677e86d$export$7e816460364ed464 = (effect)=>{
    return effect.type === 'initialize';
};
const $8d78496ee677e86d$export$eb5bd7f371e458af = (effect)=>{
    return effect.type === 'action';
};
const $8d78496ee677e86d$export$f632ad3064955f31 = (effect)=>{
    return effect.type === 'event';
};
const $8d78496ee677e86d$export$dfeb34e64fee2572 = (effect)=>{
    return effect.type === 'render';
};
function $8d78496ee677e86d$export$20b9f6acb0888554(effect) {
    return $8d78496ee677e86d$export$7e816460364ed464(effect) || $8d78496ee677e86d$export$eb5bd7f371e458af(effect) || $8d78496ee677e86d$export$f632ad3064955f31(effect);
}

});

parcelRegister("kg3OT", function(module, exports) {
const $bc3454970f51a505$export$709a27a9f80556b8 = (effect)=>{
    return effect.type === 'event';
};
const $bc3454970f51a505$export$65d7078e01574f24 = (effect)=>{
    return effect.type === 'action';
};
const $bc3454970f51a505$export$8089f608f1d0c22d = (effect)=>{
    return effect.type === 'render';
};
const $bc3454970f51a505$export$84909efba3133df = (effect)=>{
    return effect.type === 'result';
};
function $bc3454970f51a505$export$caa8cab0db5b0a61(effect) {
    return $bc3454970f51a505$export$65d7078e01574f24(effect) || $bc3454970f51a505$export$709a27a9f80556b8(effect) || $bc3454970f51a505$export$8089f608f1d0c22d(effect);
}

});

parcelRegister("gUjm2", function(module, exports) {
// From forge.ts
const $ce9f8921033c0d6d$export$3ab8eca5875a9c7e = (auxNode)=>{
    return auxNode !== null && typeof auxNode !== 'boolean' && auxNode !== undefined;
};
var $ce9f8921033c0d6d$export$c8914e6b1e019577 = /*#__PURE__*/ function(EcosystemLicenseMode) {
    EcosystemLicenseMode["USER_ACCESS"] = "USER_ACCESS";
    return EcosystemLicenseMode;
}({});
const $ce9f8921033c0d6d$export$a3b8d8814f1b9262 = (context)=>context.type === 'jira';
const $ce9f8921033c0d6d$export$d8e8de7bd6b731b7 = (extensionContext)=>extensionContext.type === 'issuePanel';
const $ce9f8921033c0d6d$export$1404d10ac8f82a03 = (extensionContext)=>extensionContext.type === 'contextConfig';
const $ce9f8921033c0d6d$export$9e5e0ca9e718a261 = (extensionContext)=>extensionContext.type === 'customField' || extensionContext.type === 'customFieldType';
const $ce9f8921033c0d6d$export$2f4ddb77a2467d4a = (extensionContext)=>extensionContext.type === 'contextMenu';
const $ce9f8921033c0d6d$export$dfe2b8f5623b1a39 = (extensionContext)=>extensionContext.type === 'contentAction';
const $ce9f8921033c0d6d$export$aee7a41cc3ed0e4 = (extensionContext)=>extensionContext.type === 'dashboardGadget';
var $ce9f8921033c0d6d$export$24835b97bd9481e3 = /*#__PURE__*/ function(CompassContextTypes) {
    CompassContextTypes["AdminPage"] = "compass:adminPage";
    CompassContextTypes["ComponentPage"] = "compass:componentPage";
    CompassContextTypes["TeamPage"] = "compass:teamPage";
    CompassContextTypes["ComponentImporter"] = "compass:componentImporter";
    return CompassContextTypes;
}({});
var $ce9f8921033c0d6d$export$1718b7e1799fa866 = /*#__PURE__*/ function(RenderingLocations) {
    RenderingLocations["AppConfigurationPage"] = "appConfigurationPage";
    RenderingLocations["OnboardingFlow"] = "onboardingFlow";
    return RenderingLocations;
}({});

});

parcelRegister("9MrOn", function(module, exports) {
/* ContentToolsButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $9VJDA = parcelRequire("9VJDA");


var $1qfLF = parcelRequire("1qfLF");


var $52EPl = parcelRequire("52EPl");

const $43c0d8bb08806c39$var$NOOP = ()=>{};
const $43c0d8bb08806c39$var$i18n = (0, $cgtv4.defineMessages)({
    triggerLabel: {
        id: "content-tools.more.icon.label",
        defaultMessage: "More actions"
    }
});
const $43c0d8bb08806c39$var$dropdownMenuCollaboratorStyle = null;
const $43c0d8bb08806c39$var$dropdownMenuNonCollaboratorStyle = null;
const $43c0d8bb08806c39$var$ContentToolsButtonComponent = ({ isDisabled: isDisabled, isOpen: isOpen = false, onOpenChange: onOpenChange = $43c0d8bb08806c39$var$NOOP, onPositioned: onPositioned = $43c0d8bb08806c39$var$NOOP, children: children, isExternalCollaborator: isExternalCollaborator = false })=>{
    const intl = (0, $8C5kA.default)();
    const [drodownMenuMaxHeight, setDropdownMenuMaxHeight] = (0, $42omo.useState)('auto');
    const dropdownMenuContainerRef = (0, $42omo.useRef)(null);
    const handleOnOpenChange = (obj)=>{
        onOpenChange(obj);
        if (obj.isOpen) {
            const distanceFromTop = dropdownMenuContainerRef.current?.getBoundingClientRect().bottom ?? 0;
            const availableHeight = window.innerHeight - distanceFromTop - 16;
            setDropdownMenuMaxHeight(`${availableHeight}px`);
        }
    };
    return /*#__PURE__*/ $42omo.createElement("div", {
        "data-id": "content-tools-dropdown-menu-container",
        "data-test-id": "content-tools-dropdown-menu-container",
        "data-testid": "content-tools-dropdown-menu-container",
        ref: dropdownMenuContainerRef,
        className: (0, $gMc0m.default)([
            "_18u019bv _1ul91tcg",
            isExternalCollaborator && "_18u0idpf _1ul91tcg"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $52EPl.default), {
        testId: "content-tools-dropdown-menu",
        appearance: "tall",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ $42omo.createElement((0, $1qfLF.default), {
                ...props,
                "data-id": "page-more-action-button",
                "data-test-id": "page-more-action-button",
                id: "tools-menu-trigger",
                label: intl.formatMessage($43c0d8bb08806c39$var$i18n.triggerLabel),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                ref: triggerRef,
                appearance: "subtle",
                isDisabled: isDisabled
            }),
        placement: "bottom-end",
        isOpen: isOpen,
        onOpenChange: handleOnOpenChange,
        shouldFlip: false,
        onPositioned: onPositioned,
        shouldRenderToParent: true
    }, /*#__PURE__*/ $42omo.createElement("div", {
        style: {
            maxHeight: drodownMenuMaxHeight
        }
    }, children || null)));
};
$43c0d8bb08806c39$var$ContentToolsButtonComponent.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).node,
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isExternalCollaborator: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    onOpenChange: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    onPositioned: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func
};
const $43c0d8bb08806c39$export$f221d384e5b0f4c3 = /*#__PURE__*/ (0, $42omo.memo)($43c0d8bb08806c39$var$ContentToolsButtonComponent);
module.exports["ContentToolsButton"] = $43c0d8bb08806c39$export$f221d384e5b0f4c3;

});


//# sourceMappingURL=ForgeContentTools.d62b1859.js.map
